import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M10.134 10.5345L11.7435 9.05851C12.184 8.65414 12.4936 8.12735 12.6326 7.54577C12.7715 6.96419 12.7335 6.35434 12.5235 5.79451L11.838 3.96001C11.5813 3.27513 11.0732 2.71388 10.4171 2.39059C9.76107 2.0673 9.00643 2.00629 8.30697 2.22001C5.73297 3.00751 3.75447 5.40001 4.36197 8.24101C4.76397 10.11 5.52897 12.456 6.98247 14.9535C8.43747 17.454 10.0995 19.3035 11.523 20.5995C13.6755 22.5585 16.7505 22.0695 18.729 20.2245C19.2593 19.73 19.5811 19.0519 19.6288 18.3283C19.6764 17.6048 19.4464 16.8903 18.9855 16.3305L17.7255 14.8005C17.3453 14.3381 16.8354 14 16.2615 13.8297C15.6876 13.6594 15.0758 13.6648 14.505 13.845L12.423 14.5005C11.8844 13.9461 11.4126 13.3303 11.0175 12.666C10.636 11.9946 10.3388 11.2787 10.1325 10.5345H10.134Z',
                    fill: '#A7ABC3',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const PbCallFilled = React.forwardRef(IconComponent);
PbCallFilled.displayName = 'PbCallFilled';

export { PbCallFilled };
